import { useMuiTheme } from "@/hooks/useMuiTheme";
import { CheckSolidIcon } from "@/svgs";
import {
  Box,
  Button,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Typography,
  type PaperProps,
} from "@mui/material";
import parse from "html-react-parser";
import { type FC } from "react";
import { useTranslation } from "react-i18next";

interface Props extends PaperProps {}

export const LifestylePackageCard: FC<Props> = (props) => {
  const theme = useMuiTheme();
  const { t } = useTranslation();

  const featuresTranslation = t("package.lifestyle.features", { returnObjects: true });
  const features = Array.isArray(featuresTranslation) ? featuresTranslation : [featuresTranslation];

  return (
    <Paper
      {...props}
      sx={{
        p: 4,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "auto",
        borderRadius: "8px 8px 48px 8px",
        position: "relative",
        overflow: "hidden",
        borderWidth: "0 1px 1px 1px",
        borderStyle: "solid",
        borderColor: "divider",
        filter: theme.palette.filter.shadow200,
        transition: "filter 150ms ease-out",
        ":hover": {
          filter: theme.palette.filter.shadow400,
        },
        isolation: "isolate",
        "::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          bottom: "auto",
          height: 8,
          width: "100%",
          backgroundImage: "linear-gradient(87.37deg, #ABBABB -23.44%, #FCF8F1 109.47%)",
        },
        ...props.sx,
      }}
    >
      <Stack spacing={0.5}>
        <Typography variant="caption3" color="text.darkblue">
          {t("package.lifestyle.name")}
        </Typography>
        <Typography variant="h2" color="text.darkblue">
          <Typography component="span" variant="inherit" fontWeight={400}>
            ฿
          </Typography>
          <Typography component="span" variant="inherit">
            5,900
          </Typography>
        </Typography>
        <Typography variant="body2" color="translucent.black.56">
          <Typography component="span" variant="inherit">
            {t("from")}{" "}
          </Typography>
          <Typography component="span" variant="inherit">
            ฿7,900
          </Typography>
          {/* <Typography component="span" variant="inherit">
            {t("baht")}
          </Typography> */}
        </Typography>
      </Stack>
      <Typography
        variant="caption4"
        color="text.black"
        sx={{
          mt: 2,
        }}
        whiteSpace="pre-line"
      >
        {t("package.lifestyle.description")}
      </Typography>
      <Divider sx={{ my: 2 }} />
      <List>
        {features.map((feature) => {
          return (
            <ListItem key={feature} sx={{ alignItems: "flex-start" }}>
              <ListItemIcon sx={{ color: "success.main", mt: 0 }}>
                <CheckSolidIcon width={32} height={32} />
              </ListItemIcon>
              <ListItemText>
                <Typography variant="body2">{parse(feature)}</Typography>
              </ListItemText>
            </ListItem>
          );
        })}
      </List>
      <Box pt={4} mt="auto">
        <Button
          component="a"
          href="https://lin.ee/yklrqjG"
          target="_blank"
          rel="noreferrer nofollow"
          variant="contained"
          color="black"
          fullWidth
          sx={{ borderRadius: 999 }}
        >
          {t("package.lifestyle.button-text")}
        </Button>
      </Box>
    </Paper>
  );
};

// const features = [
//   "Meal type สัดส่วนอาหารที่เหมาะสม",
//   "Nutrients you need วิตามินและแร่ธาตุ ที่ควรเสริม",
//   "Weight management การควบคุมน้ำหนัก",
//   "Beauty insights ผิวพรรณและความงาม",
//   "Food & Beverage reaction การตอบสนองต่ออาหาร และเครื่องดื่ม",
// ];
